import { USER_LOAN_PROGRAM } from '@/config/constants';
import type { PropertyView } from '@/types/PropertyView';

/** True when the property / profile is on a cash (no-mortgage) purchase path. */
export function isCashLoanProgram(program: string | null | undefined): boolean {
  if (!program) return false;
  const p = String(program).toLowerCase().trim();
  return p === USER_LOAN_PROGRAM.CASH || p === 'cash';
}

export function isCashPurchaseProperty(property: PropertyView): boolean {
  return isCashLoanProgram(property.loanProgram);
}
